import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import { NoticeService } from 'src/app/core/service/notice.service';
import { NoticeEdit } from '../model/noticeEdit';
import moment from 'moment';

@Component({
  selector: 'app-notice-scroll',
  templateUrl: './notice-scroll.component.html',
  styleUrls: ['./notice-scroll.component.scss']
})
export class NoticeScrollComponent implements OnInit, OnDestroy
{
  public notices: NoticeEdit[] = [];
  public dismissConfirmationOpened = false;
  public noticeToDismiss: number;
  public noticesLoading = true;
  public notice: any = null;
  public visibleIndex = 0;

  /**
   * Current logged in userId
   */
  public currentUserId: number;

  private timeLeft = 60;
  private interval;

  constructor(
    private authenticationService: AuthenticationService,
    private noticeService: NoticeService
  ) { }

  public ngOnInit(): void
  {
    const user = this.authenticationService.currentUser;
    this.currentUserId = user ? user.id : 0;
    this.loadNotices();
  }

  public ngOnDestroy(): void
  {
    clearInterval(this.interval);
  }

  public dismissNotice(confirm: boolean): void
  {
    this.next();
    if (confirm)
    {
      this.noticeService.dismissNotice(this.currentUserId, this.noticeToDismiss).subscribe({
        next: () =>
        {
          this.loadNotices();
        }
      });
    }
    this.dismissConfirmationOpened = false;
  }

  public confirmDismissNotice(noticeId: number): void
  {
    this.noticeToDismiss = noticeId;
    this.dismissConfirmationOpened = true;
    this.pauseTimer();
  }

  public next(): void
  {
    this.visibleIndex++;
    if (this.visibleIndex > this.notices.length - 1)
    {
      this.visibleIndex = 0;
    }
    this.notice = this.notices[this.visibleIndex];
    this.pauseTimer();
    this.startTimer();
  }

  public previous(): void
  {
    this.visibleIndex--;
    if (this.visibleIndex < 0)
    {
      this.visibleIndex = this.notices.length - 1;
    }
    this.notice = this.notices[this.visibleIndex];
    this.pauseTimer();
    this.startTimer();
  }

  public loadNotice(selected: number): void
  {
    this.visibleIndex = selected;
    this.notice = this.notices[this.visibleIndex];
    this.pauseTimer();
    this.startTimer();
  }

  private startTimer()
  {
    this.interval = setInterval(() =>
    {
      if (this.timeLeft > 0)
      {
        this.timeLeft--;
        this.next();
      } else
      {
        this.timeLeft = 60;
      }
    }, 10000);
  }

  private pauseTimer()
  {
    clearInterval(this.interval);
  }

  private loadNotices()
  {
    this.noticeService.getNoticeDashboard(this.currentUserId, moment.utc().toISOString().replace('Z', '')).subscribe({
      next: (data) =>
      {
        this.notices = data;
        this.visibleIndex = data.length > 0 ? 0 : -1;
        this.notice = this.visibleIndex !== -1 ? this.notices[this.visibleIndex] : null;
        this.noticesLoading = false;
        if (this.notice !== null)
        {
          this.startTimer();
        }
      }
    });
  }
}
